import BatchClaimerABI from './abis/BatchClaimer.js';
import BoostNftABI from './abis/BoostNFT.js';
import CoreProxyABI from './abis/CoreProxy.js';
import DappMaintenanceABI from './abis/DappMaintenance.js';
import ERC20ABI from './abis/ERC20.js';
import GnosisSafeL2ProxyABI from './abis/GnosisSafeL2Proxy.js';
import KwentaStakingRewardsV2ABI from './abis/KwentaStakingRewardsV2.js';
import MarginEngineBaseAbi from './abis/MarginEngineBase.js';
import MulticallABI from './abis/Multicall3_1.js';
import MultipleMerkleDistributorOpABI from './abis/MultipleMerkleDistributorOp.js';
import MultipleMerkleDistributorPerpsV2ABI from './abis/MultipleMerkleDistributorPerpsV2.js';
import PerpsV2MarketDataABI from './abis/PerpsV2MarketData.js';
import PerpsV2MarketSettingsABI from './abis/PerpsV2MarketSettings.js';
import PerpsV3AccountProxyABI from './abis/PerpsV3AccountProxy.js';
import PerpsV3MarketProxyABI from './abis/PerpsV3MarketProxy.js';
import PythABI from './abis/Pyth.js';
import RewardEscrowV2ABI from './abis/RewardEscrowV2.js';
import SmartMarginAccountFactoryAbi from './abis/SmartMarginAccountFactory.js';
import SpotV3MarketProxy from './abis/SpotV3MarketProxy.js';
import SynthUtilABI from './abis/SynthUtil.js';
import SynthetixV3ProxyABI from './abis/SynthetixV3Proxy.js';
import SystemStatusABI from './abis/SystemStatus.js';
import { COMMON_ADDRESSES, KWENTA_ADDRESSES, SNX_V2_PERPS_ADDRESSES, SNX_V3_PERPS_ADDRESSES, TOKEN_ADDRESSES, } from './constants.js';
export const snxV2ContractsByNetwork = (networkId) => {
    return {
        PerpsV2MarketData: {
            address: SNX_V2_PERPS_ADDRESSES.PerpsV2MarketData[networkId],
            abi: PerpsV2MarketDataABI,
        },
        PerpsV2MarketSettings: {
            address: SNX_V2_PERPS_ADDRESSES.PerpsV2MarketSettings[networkId],
            abi: PerpsV2MarketSettingsABI,
        },
        SmartMarginAccountFactory: {
            address: SNX_V2_PERPS_ADDRESSES.SmartMarginAccountFactory[networkId],
            abi: SmartMarginAccountFactoryAbi,
        },
    };
};
export const snxV3ContractsByNetwork = (networkId) => {
    return {
        PerpsV3MarketProxy: {
            address: SNX_V3_PERPS_ADDRESSES.PerpsV3MarketProxy[networkId],
            abi: PerpsV3MarketProxyABI,
        },
        PerpsV3AccountProxy: {
            address: SNX_V3_PERPS_ADDRESSES.PerpsV3AccountProxy[networkId],
            abi: PerpsV3AccountProxyABI,
        },
        SpotV3MarketProxy: {
            address: SNX_V3_PERPS_ADDRESSES.SpotV3MarketProxy[networkId],
            abi: SpotV3MarketProxy,
        },
        SynthetixV3Proxy: {
            address: SNX_V3_PERPS_ADDRESSES.SynthetixV3Proxy[networkId],
            abi: SynthetixV3ProxyABI,
        },
        CoreProxy: {
            address: SNX_V3_PERPS_ADDRESSES.CoreProxy[networkId],
            abi: CoreProxyABI,
        },
        MarginEngine: {
            address: SNX_V3_PERPS_ADDRESSES.MarginEngine[networkId],
            abi: MarginEngineBaseAbi,
        },
    };
};
export const kwentaContractsByNetwork = (networkId) => {
    if (networkId === 10) {
        return {
            KwentaToken: KWENTA_ADDRESSES.KwentaToken[networkId]
                ? {
                    address: KWENTA_ADDRESSES.KwentaToken[networkId],
                    abi: ERC20ABI,
                }
                : undefined,
            MultipleMerkleDistributorPerpsV2: KWENTA_ADDRESSES.TradingRewardsPerpsV2[networkId]
                ? {
                    address: KWENTA_ADDRESSES.TradingRewardsPerpsV2[networkId],
                    abi: MultipleMerkleDistributorPerpsV2ABI,
                }
                : undefined,
            MultipleMerkleDistributorStakingV2: KWENTA_ADDRESSES.TradingRewardsStakingV2[networkId]
                ? {
                    address: KWENTA_ADDRESSES.TradingRewardsStakingV2[networkId],
                    abi: MultipleMerkleDistributorPerpsV2ABI,
                }
                : undefined,
            MultipleMerkleDistributorOp: KWENTA_ADDRESSES.OpRewards[networkId]
                ? {
                    address: KWENTA_ADDRESSES.OpRewards[networkId],
                    abi: MultipleMerkleDistributorOpABI,
                }
                : undefined,
            MultipleMerkleDistributorSnxOp: KWENTA_ADDRESSES.SnxOpRewards[networkId]
                ? {
                    address: KWENTA_ADDRESSES.SnxOpRewards[networkId],
                    abi: MultipleMerkleDistributorOpABI,
                }
                : undefined,
            MultipleMerkleDistributorOpReferral: KWENTA_ADDRESSES.OpReferralRewards[networkId]
                ? {
                    address: KWENTA_ADDRESSES.OpReferralRewards[networkId],
                    abi: MultipleMerkleDistributorOpABI,
                }
                : undefined,
            BatchClaimer: KWENTA_ADDRESSES.BatchClaimer[networkId]
                ? {
                    address: KWENTA_ADDRESSES.BatchClaimer[networkId],
                    abi: BatchClaimerABI,
                }
                : undefined,
            KwentaStakingRewardsV2: KWENTA_ADDRESSES.KwentaStakingRewardsV2[networkId]
                ? {
                    address: KWENTA_ADDRESSES.KwentaStakingRewardsV2[networkId],
                    abi: KwentaStakingRewardsV2ABI,
                }
                : undefined,
            RewardEscrowV2: KWENTA_ADDRESSES.RewardEscrowV2[networkId]
                ? {
                    address: KWENTA_ADDRESSES.RewardEscrowV2[networkId],
                    abi: RewardEscrowV2ABI,
                }
                : undefined,
            BoostNft: KWENTA_ADDRESSES.BoostNft[networkId]
                ? {
                    address: KWENTA_ADDRESSES.BoostNft[networkId],
                    abi: BoostNftABI,
                }
                : undefined,
        };
    }
    else {
        return {};
    }
};
export const commonContractsByNetwork = (networkId) => {
    return {
        SystemStatus: COMMON_ADDRESSES.SystemStatus[networkId]
            ? {
                address: COMMON_ADDRESSES.SystemStatus[networkId],
                abi: SystemStatusABI,
            }
            : undefined,
        SynthUtil: COMMON_ADDRESSES.SynthUtil[networkId]
            ? {
                address: COMMON_ADDRESSES.SynthUtil[networkId],
                abi: SynthUtilABI,
            }
            : undefined,
        Pyth: COMMON_ADDRESSES.Pyth[networkId]
            ? {
                address: COMMON_ADDRESSES.Pyth[networkId],
                abi: PythABI,
            }
            : undefined,
        DappMaintenance: COMMON_ADDRESSES.DappMaintenance[networkId]
            ? {
                address: COMMON_ADDRESSES.DappMaintenance[networkId],
                abi: DappMaintenanceABI,
            }
            : undefined,
        MultiCall3_1: COMMON_ADDRESSES.Multicall3_1[networkId]
            ? {
                address: COMMON_ADDRESSES.Multicall3_1[networkId],
                abi: MulticallABI,
            }
            : undefined,
        GnosisSafeL2: COMMON_ADDRESSES.GnosisSafeL2[networkId]
            ? {
                address: COMMON_ADDRESSES.GnosisSafeL2[networkId],
                abi: GnosisSafeL2ProxyABI,
            }
            : undefined,
    };
};
export const tokenContractsByNetwork = (networkId) => {
    return {
        SUSD: TOKEN_ADDRESSES.SUSD[networkId]
            ? {
                address: TOKEN_ADDRESSES.SUSD[networkId],
                abi: ERC20ABI,
            }
            : undefined,
        USDC: TOKEN_ADDRESSES.USDC[networkId]
            ? {
                address: TOKEN_ADDRESSES.USDC[networkId],
                abi: ERC20ABI,
            }
            : undefined,
        DAI: TOKEN_ADDRESSES.DAI[networkId]
            ? {
                address: TOKEN_ADDRESSES.DAI[networkId],
                abi: ERC20ABI,
            }
            : undefined,
        WETH: TOKEN_ADDRESSES.WETH[networkId]
            ? {
                address: TOKEN_ADDRESSES.WETH[networkId],
                abi: ERC20ABI,
            }
            : undefined,
        sUSDC: TOKEN_ADDRESSES.sUSDC[networkId]
            ? {
                address: TOKEN_ADDRESSES.sUSDC[networkId],
                abi: ERC20ABI,
            }
            : undefined,
        USDx: TOKEN_ADDRESSES.USDx[networkId]
            ? {
                address: TOKEN_ADDRESSES.USDx[networkId],
                abi: ERC20ABI,
            }
            : undefined,
        cbBTC: TOKEN_ADDRESSES.cbBTC[networkId]
            ? {
                address: TOKEN_ADDRESSES.cbBTC[networkId],
                abi: ERC20ABI,
            }
            : undefined,
        scbBTC: TOKEN_ADDRESSES.scbBTC[networkId]
            ? {
                address: TOKEN_ADDRESSES.scbBTC[networkId],
                abi: ERC20ABI,
            }
            : undefined,
        cbETH: TOKEN_ADDRESSES.cbETH[networkId]
            ? {
                address: TOKEN_ADDRESSES.cbETH[networkId],
                abi: ERC20ABI,
            }
            : undefined,
        scbETH: TOKEN_ADDRESSES.scbETH[networkId]
            ? {
                address: TOKEN_ADDRESSES.scbETH[networkId],
                abi: ERC20ABI,
            }
            : undefined,
        wstETH: TOKEN_ADDRESSES.wstETH[networkId]
            ? {
                address: TOKEN_ADDRESSES.wstETH[networkId],
                abi: ERC20ABI,
            }
            : undefined,
        swstETH: TOKEN_ADDRESSES.swstETH[networkId]
            ? {
                address: TOKEN_ADDRESSES.swstETH[networkId],
                abi: ERC20ABI,
            }
            : undefined,
    };
};
export const allContractsByNetwork = (networkId) => {
    return {
        snxV3: snxV3ContractsByNetwork(networkId),
        snxV2: snxV2ContractsByNetwork(networkId),
        kwenta: kwentaContractsByNetwork(networkId),
        common: commonContractsByNetwork(networkId),
        tokens: tokenContractsByNetwork(networkId),
    };
};
//# sourceMappingURL=index.js.map